<template>
    <div class="container-fluid m-0 p-0">
        <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
            <div class="col-sm-12 h-100 my-auto p-0 m-0">
                <span class="mx-3 font-weight-bold lead">Hospital List</span>
                <span class="mx-3">
                    <button class="btn btn-sm btn-outline-primary font-weight-bolder"
                            data-toggle="modal"
                            data-target="#add-hospital"
                    >
                        <span class="fas fa-plus"></span>
                        Add Hospital
                    </button>
                </span>
                <span class="float-right py-1 mx-2 pr-4">
                    <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                            @click="goBack"
                    >
                        <span class="fas fa-backward"></span>
                        Go Back
                    </button>
                </span>
            </div>
        </div>

        <div class="row text-small pt-3">
            <div class="col col-md-12" style="min-height: 450px !important;">

                <div class="form-group form-inline">
                    <label for="inputUser" class="pr-3 font-weight-bold">Search Hospital Here: </label>
                    <input class="form-control form-control-sm mr-2 w-25" id="inputUser" style=""
                           type="text" placeholder="Input Any Here . . ."
                           v-model="params.searchValue"
                    >
                    <button type="button" class="btn btn-primary btn-sm"
                            @click="params = {}; setPage(1)"
                    >CLEAR</button>

                    <label for="country" class="pr-3 font-weight-bold ml-5">Country: </label>
                    <select id="country" class="form-control form-control-xs input-group-append"
                            v-model="params.country_id"
                    >
                        <option :value="undefined">--- All ---</option>
                        <option v-for="countryKey in countryKeys" :key="countryKey.id"
                            :value="countryKey.id">{{ countryKey.name }}</option>
                    </select>

                </div>

                <div class=" table-responsive text-small" style="height: 475px;">
                    <table  class="table table-hover table-bordered table-template-1 text-small sticky-header">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th class="col-name">HOSPITAL CODE</th>
                            <th>HOSPITAL NAME</th>
                            <th>COUNTRY</th>
                            <th class="col-actions">ACTION</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(hospital, index) in hospitals" :key="hospital.id">
                            <td>{{ index + pagination.from }}</td>
                            <td>{{ hospital.code }}</td>
                            <td>{{ hospital.name }}</td>
                            <td>{{ hospital.country }}</td>
                            <td class="text-center col-actions">
                                <button class="btn btn-sm btn-xs btn-outline-info font-weight-bolder mr-1 ml-auto"
                                        data-toggle="modal"
                                        data-target="#view-hospital"
                                        @click="viewHospital = hospital"
                                >
                                    <span class="fas fa-eye"></span>
                                    View
                                </button>
                                <button class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder mr-1 ml-auto"
                                        @click="confirmDeleteHospital(hospital.id)"
                                >
                                    <span class="fas fa-trash-alt"></span>
                                    Delete
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <nav aria-label="..." class="ml-3 pt-2">
                <ul class="pagination text-smallest">
                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                        <button class="page-link" @click="setPage(1)">First</button>
                    </li>

                    <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                        <button class="page-link" @click="setPage(page)">{{ page }}</button>
                    </li>

                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                        <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
                    </li>
                </ul>
            </nav>

        </div>

        <view-hospital :view-hospital="viewHospital"></view-hospital>
        <add-hospital></add-hospital>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { paginationMixin } from "@/mixins/paginationMixin";

import ViewHospital from "@/components/sub_components/admin/hospitals/ViewHospital";
import AddHospital from "@/components/sub_components/admin/hospitals/AddHospital";

export default {
    name: "HospitalIndex",

    mixins: [ vueAppMixin, paginationMixin ],

    components: { ViewHospital, AddHospital },

    data() {
        return {
            params: {
                searchValue: '',
            },
            viewHospital: {}
        }
    },

    methods: {
        ...mapActions([
            'getHospitalList',
            'getCountryKeys',
            'deleteHospital',
            'getOtherCountryKeys'
        ]),

        setPage(page) {
            this.pagination.currentPage = page;
            // let params = { searchValue: this.searchValue, page: page };
            let params = this.params;
            params['page'] = page;
            this.getHospitalList(params);
        },

        async confirmDeleteHospital(hospitalId) {
            if(await this.confirmDeleteAlert()) {
                let deletedHospital = await this.deleteHospital({ id: hospitalId});
                if(deletedHospital) {
                    this.successAlert('Hospital Successfully Deleted', 'DELETE');
                } else {
                    this.errorAlert('Hospital Failed to Delete', 'DELETE');
                }
            }
        }
    },

    computed: {
        ...mapGetters([
            'hospitals',
            'countryKeys'
        ])
    },

    created() {
        this.getHospitalList({});
        this.getCountryKeys();
        this.getOtherCountryKeys();
        this.searchHospital = _.debounce(() => {
            this.setPage(0);
        }, 500);
    },

    watch: {
        'params.searchValue'() {
            this.searchHospital();
        },
        'params.country_id'() {
            this.setPage(0);
        },
    }
}
</script>

<style scoped>

</style>